export const titleRegistrationRoutes = {
    'transactionselection': '/titleregistration/transactionselection',
    'vehicleremovesoldnotice': '/titleregistration/vehicleremovesoldnotice',
    'registrationonly': '/titleregistration/registrationonly',
    'titleonly': '/titleregistration/titleonly',
    'vehicleownership': '/titleregistration/vehicleownership',
    'correcttitlevehicle': '/titleregistration/correcttitlevehicle',
    'correcttitlevehicleownership': '/titleregistration/correcttitlevehicleownership',
    'correcttitletitle': '/titleregistration/correcttitletitle',
    'vehicle': '/titleregistration/vehicle',
    'confirmation': '/titleregistration/confirmation',
    'vehiclefirst': '/titleregistration/vehiclefirst',
    'placardcustomer': '/titleregistration/placardcustomer',
    'temporaryplacard': '/titleregistration/temporaryplacard',
    'placardtransactionselection': '/titleregistration/placardtransactionselection',
    'issuesoldnotice': '/titleregistration/issuesoldnotice',
    'removesoldnotice': '/titleregistration/removesoldnotice',
    'issuepermanentplacard': '/titleregistration/issuepermanentplacard',
    'renewpermanentplacard': '/titleregistration/renewpermanentplacard',
    'finalize': '/titleregistration/finalize',
    'canceltitle': '/titleregistration/canceltitle',
    'canceltitleresults': '/titleregistration/canceltitleresults',
    'issuepermit': '/titleregistration/issuepermit',
    'issuepermitcustomer': '/titleregistration/issuepermitcustomer',
    'registrationrenew': '/titleregistration/registrationrenew',
    'registrationviewonly': '/titleregistration/registrationviewonly',
    'template': '/titleregistration/template'
};
